"use client";

import { useEffect, useState } from "react";

// Problem images - JPG
import problems01Jpg from "../../public/problems_01.jpg";
// Problem images - WebP 400w
import problems01Webp400w from "../../public/problems_01-400w.webp";
// Problem images - WebP 800w
import problems01Webp800w from "../../public/problems_01-800w.webp";
import problems02Jpg from "../../public/problems_02.jpg";
import problems02Webp400w from "../../public/problems_02-400w.webp";
import problems02Webp800w from "../../public/problems_02-800w.webp";
import problems03Jpg from "../../public/problems_03.jpg";
import problems03Webp400w from "../../public/problems_03-400w.webp";
import problems03Webp800w from "../../public/problems_03-800w.webp";
import problems04Jpg from "../../public/problems_04.jpg";
import problems04Webp400w from "../../public/problems_04-400w.webp";
import problems04Webp800w from "../../public/problems_04-800w.webp";
import problems05Jpg from "../../public/problems_05.jpg";
import problems05Webp400w from "../../public/problems_05-400w.webp";
import problems05Webp800w from "../../public/problems_05-800w.webp";
import problems06Jpg from "../../public/problems_06.jpg";
import problems06Webp400w from "../../public/problems_06-400w.webp";
import problems06Webp800w from "../../public/problems_06-800w.webp";
import problems07Jpg from "../../public/problems_07.jpg";
import problems07Webp400w from "../../public/problems_07-400w.webp";
import problems07Webp800w from "../../public/problems_07-800w.webp";
import problems08Jpg from "../../public/problems_08.jpg";
import problems08Webp400w from "../../public/problems_08-400w.webp";
import problems08Webp800w from "../../public/problems_08-800w.webp";
import problems09Jpg from "../../public/problems_09.jpg";
import problems09Webp400w from "../../public/problems_09-400w.webp";
import problems09Webp800w from "../../public/problems_09-800w.webp";
import problems10Jpg from "../../public/problems_10.jpg";
import problems10Webp400w from "../../public/problems_10-400w.webp";
import problems10Webp800w from "../../public/problems_10-800w.webp";

export default function ProblemsSection() {
	const [activeProblem, setActiveProblem] = useState(0);
	const [isTransitioning, setIsTransitioning] = useState(false);

	const problems = [
		{
			quote:
				"Every article says something different about recovery runs. But none of them know I'm training for a sub-4 marathon, ran 60k last week, and had a stress fracture last year. I need advice that's actually <strong>mine</strong>.",
			name: "Sarah Chen",
			handle: "@running_sarah",
			image: problems01Jpg,
			webp400w: problems01Webp400w,
			webp800w: problems01Webp800w,
		},
		{
			quote:
				"Asked my coach friend about pacing strategy, but I felt awkward bringing it up again three days later when my plan changed. Sometimes I just want to think out loud without bothering anyone...",
			name: "James Mitchell",
			handle: "@jmitchell_runs",
			image: problems02Jpg,
			webp400w: problems02Webp400w,
			webp800w: problems02Webp800w,
		},
		{
			quote:
				"Searched 'knee pain after long run' and got 10,000 results. But which one applies to MY knee, MY mileage, MY running form, MY history? Generic answers feel like guessing.",
			name: "Emma Torres",
			handle: "@emmarunsfast",
			image: problems03Jpg,
			webp400w: problems03Webp400w,
			webp800w: problems03Webp800w,
		},
		{
			quote:
				"Woke up tired with HRV at 45. Have a tempo run today. I know the theory, but should <strong>I</strong> do it given <strong>my</strong> training block, <strong>my</strong> race in 8 weeks, <strong>my</strong> sleep last week? There's no formula for this.",
			name: "David Park",
			handle: "@parkrunner",
			image: problems04Jpg,
			webp400w: problems04Webp400w,
			webp800w: problems04Webp800w,
		},
		{
			quote:
				"Got slower on my easy runs this month. Is it overtraining? Stress? Bad shoes? I'd ask my running group, but honestly... it feels like a dumb question. Wish I could just talk it through privately.",
			name: "Lisa Anderson",
			handle: "@lisaruns_alot",
			image: problems05Jpg,
			webp400w: problems05Webp400w,
			webp800w: problems05Webp800w,
		},
		{
			quote:
				"Just started running 3 months ago. Is my breathing supposed to be this hard? Am I too slow? Too fast? YouTube says one thing, Reddit says another. Nobody knows I'm 38, recovering from COVID, and have never done sports before.",
			name: "Marcus Webb",
			handle: "@marcusontherun",
			image: problems06Jpg,
			webp400w: problems06Webp400w,
			webp800w: problems06Webp800w,
		},
		{
			quote:
				"Gained 2kg and now my half marathon pace feels harder. Should I eat less? Run more? Everyone's advice is different and nobody knows my body, my metabolism, or that I'm already running 50k/week.",
			name: "Nina Kowalski",
			handle: "@nina_runs_free",
			image: problems07Jpg,
			webp400w: problems07Webp400w,
			webp800w: problems07Webp800w,
		},
		{
			quote:
				"Missed 4 days of training because of work travel. Do I make it up? Skip it? Jump back in? I don't want to bother my training group with 'silly' questions, but winging it doesn't feel right either.",
			name: "Alex Ramirez",
			handle: "@ramirez_racing",
			image: problems08Jpg,
			webp400w: problems08Webp400w,
			webp800w: problems08Webp800w,
		},
		{
			quote:
				"Race is in 2 weeks but I feel undertrained. Should I squeeze in one more long run? Taper more? The race plan I found online doesn't know I had a cold 3 weeks ago and missed key workouts.",
			name: "Sophie Laurent",
			handle: "@sophieruns",
			image: problems09Jpg,
			webp400w: problems09Webp400w,
			webp800w: problems09Webp800w,
		},
		{
			quote:
				"Everyone says 'listen to your body' but what does that even mean? My legs are sore, but is it good sore or injury sore? How do I know if <strong>I</strong> specifically should push through or rest? Not asking the group chat because I don't want to sound clueless.",
			name: "Tom Richardson",
			handle: "@tom_running_life",
			image: problems10Jpg,
			webp400w: problems10Webp400w,
			webp800w: problems10Webp800w,
		},
	];

	useEffect(() => {
		const interval = setInterval(() => {
			setIsTransitioning(true);
			setTimeout(() => {
				setActiveProblem((prev) => (prev + 1) % problems.length);
				setTimeout(() => {
					setIsTransitioning(false);
				}, 100);
			}, 300);
		}, 12000); // 12 seconds per problem card

		return () => clearInterval(interval);
	}, [problems.length]);

	const handleNavigationClick = (index: number) => {
		setIsTransitioning(true);
		setTimeout(() => {
			setActiveProblem(index);
			setTimeout(() => {
				setIsTransitioning(false);
			}, 100);
		}, 300);
	};

	return (
		<div className="w-full border-b border-[rgba(55,50,47,0.12)] flex flex-col justify-center items-center">
			{/* Problem Content */}
			<div className="self-stretch px-2 overflow-hidden flex justify-start items-center bg-background border border-b border-l-0 border-r-0 border-t-0">
				<div className="flex-1 py-16 md:py-17 flex flex-col md:flex-row justify-center items-end gap-6">
					<div className="self-stretch px-3 md:px-12 justify-center items-start gap-4 flex flex-col md:flex-row">
						<picture>
							<source
								srcSet={`${problems[activeProblem]?.webp400w} 400w, ${problems[activeProblem]?.webp800w} 800w`}
								sizes="(max-width: 768px) 192px, 192px"
								type="image/webp"
							/>
							<img
								className="w-48 h-50 md:w-48 md:h-50 rounded-lg object-cover transition-all duration-700 ease-in-out"
								style={{
									opacity: isTransitioning ? 0.6 : 1,
									transform: isTransitioning ? "scale(0.95)" : "scale(1)",
									transition:
										"opacity 0.7s ease-in-out, transform 0.7s ease-in-out",
								}}
								src={problems[activeProblem]?.image ?? ""}
								alt={problems[activeProblem]?.name ?? ""}
								width="1024"
								height="1024"
							/>
						</picture>
						<div className="flex-1 px-6 py-6 shadow-[0px_0px_0px_0.75px_rgba(50,45,43,0.12)] overflow-hidden flex flex-col justify-start items-start gap-6 shadow-none pb-0 pt-0">
							<div
								className="self-stretch text-[#49423D] text-xl md:text-[26px] font-medium leading-8 md:leading-[36px] font-sans h-[200px] md:h-[210px] overflow-hidden line-clamp-5 transition-all duration-700 ease-in-out tracking-tight"
								style={{
									filter: isTransitioning ? "blur(4px)" : "blur(0px)",
									transition: "filter 0.7s ease-in-out",
								}}
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Static content with intentional HTML formatting
								dangerouslySetInnerHTML={{
									__html: `&ldquo;${problems[activeProblem]?.quote ?? ""}&rdquo;`,
								}}
							/>
							<div
								className="self-stretch flex flex-col justify-start items-start gap-1 transition-all duration-700 ease-in-out"
								style={{
									filter: isTransitioning ? "blur(4px)" : "blur(0px)",
									transition: "filter 0.7s ease-in-out",
								}}
							>
								<div className="self-stretch justify-center flex flex-col text-[rgba(73,66,61,0.90)] text-lg font-medium leading-[26px] font-sans">
									{problems[activeProblem]?.name}
								</div>
								<div className="self-stretch justify-center flex flex-col text-[rgba(73,66,61,0.70)] text-lg font-medium leading-[26px] font-sans">
									{problems[activeProblem]?.handle}
								</div>
							</div>
						</div>
					</div>

					{/* Navigation Arrows */}
					<div className="pr-6 justify-start items-start gap-[14px] flex">
						<button
							type="button"
							onClick={() =>
								handleNavigationClick(
									(activeProblem - 1 + problems.length) % problems.length,
								)
							}
							className="w-9 h-9 shadow-[0px_1px_2px_rgba(0,0,0,0.08)] overflow-hidden rounded-full border border-[rgba(0,0,0,0.15)] justify-center items-center gap-2 flex hover:bg-gray-50 transition-colors"
						>
							<div className="w-6 h-6 relative overflow-hidden">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									role="img"
									aria-label="Previous problem"
								>
									<path
										d="M15 18L9 12L15 6"
										stroke="#46413E"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</div>
						</button>
						<button
							type="button"
							onClick={() =>
								handleNavigationClick((activeProblem + 1) % problems.length)
							}
							className="w-9 h-9 shadow-[0px_1px_2px_rgba(0,0,0,0.08)] overflow-hidden rounded-full border border-[rgba(0,0,0,0.15)] justify-center items-center gap-2 flex hover:bg-gray-50 transition-colors"
						>
							<div className="w-6 h-6 relative overflow-hidden">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									role="img"
									aria-label="Next problem"
								>
									<path
										d="M9 18L15 12L9 6"
										stroke="#46413E"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
